import Component from 'flarum/Component';

export default class extends Component {
  init() {
    let ads = this.props.ads;
    this.img = ads[this.props.align].img;
    this.url = ads[this.props.align].url;
  }

  view() {
    return (
      <div>
        <a href={this.url} class={'ad-column__link--' + ((this.props.align === 'left') ? 'left' : 'right')} target="_blank">
          <img src={this.img} class={'ad ad-column__img--' + ((this.props.align === 'left') ? 'left' : 'right')} />
        </a>
      </div>
    );
  }
}
